<template>
  <div>
    <b-modal
      v-model="isError"
      :active="isError"
      :width="1000"
      full-screen
      height="1500"
      scroll="keep"
      :on-cancel="
        () => {
          isError = false
        }
      "
    >
      <div class="card">
        <div class="card-content">
          <header class="modal-card-head">
            <p class="modal-card-title"></p>
            <p class="modal-card-title m-b-0">
              <span><img width="120px" :src="tots_image"/></span>
            </p>

            <button class="delete" type="button" @click="closePopUp"></button>
          </header>

          <template>
            <div>
              <section class="container section page-header section is-main-section">
                <error-page></error-page>
              </section>
            </div>
          </template>
        </div>
      </div>
    </b-modal>
    <b-modal
      v-model="isSuccess"
      :active="isSuccess"
      :width="1000"
      full-screen
      height="1500"
      scroll="keep"
      :on-cancel="
        () => {
          isSuccess = false
        }
      "
    >
      <div class="card">
        <div class="card-content">
          <header class="modal-card-head">
            <p class="modal-card-title m-b-0">
              <span><img width="120px" :src="tots_image"/></span>
            </p>

            <button class="delete" type="button" @click="closePopUp"></button>
          </header>

          <template>
            <div>
              <section class="container section page-header section is-main-section">
                <thank-you :sendCaptureRespos="sendCaptureRespos" :isPrint="isPrint"></thank-you>
              </section>
            </div>
          </template>
        </div>
      </div>
    </b-modal>

    <section class="container section page-header section is-main-section">
      <div class="columns">
        <div class="column customer_details p-t-10  m-l-15">
          <table class="table is-fullwidth m-b-10 p-l-15">
            <tr>
              <th>Name :</th>
              <td>{{ info.enquiry && info.enquiry.studentFirstName ? info.enquiry.studentFirstName : '-' }}</td>
            </tr>
            <tr>
              <th>Gender :</th>
              <td>{{ info.enquiry && info.enquiry.gender ? info.enquiry.gender : '-' }}</td>
            </tr>

            <tr>
              <th>Class</th>
              <td>
                {{ info.studentClass && info.studentClass.name ? info.studentClass.name : '-' }}
              </td>
            </tr>
          </table>
        </div>

        <div class="column customer_details p-t-5  m-l-5">
          <table class="table is-fullwidth m-b-5 p-l-5">
            <tr>
              <th>Parent Name</th>
              <td>
                {{ info.enquiry && info.enquiry.fatherName ? info.enquiry.fatherName : '-' }}
              </td>
            </tr>

            <tr>
              <th>Parent No</th>
              <td>
                {{ info.enquiry && info.enquiry.fatherMobile ? info.enquiry.fatherMobile : '-' }}
              </td>
            </tr>
            <tr>
              <th>Parent Email Id</th>
              <td>
                {{ info.enquiry && info.enquiry.fatherEmailID ? info.enquiry.fatherEmailID : '-' }}
              </td>
            </tr>
          </table>
        </div>

        <div class="column customer_details p-t-10  m-l-15">
          <table class="table is-fullwidth m-b-10 p-l-15">
            <tr>
              <th>Fee Type Name</th>
              <td>
                {{ info && info.feeTypeName ? info.feeTypeName : '-' }}
              </td>
            </tr>

            <tr>
              <th>Franchisee</th>
              <td>
                {{ info.franchisee && info.franchisee.companyName ? info.franchisee.companyName : '-' }}
              </td>
            </tr>
            <tr>
              <th>Acadamic Year</th>
              <td>
                {{ info.franchiseeAcademicYear && info.franchiseeAcademicYear.academicYear ? info.franchiseeAcademicYear.academicYear : '-' }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </section>
    <section class="section is-main-section">
      <card-component title class="has-table has-mobile-sort-spaced">
        <b-table :striped="true" @check="getActiveAmount" :hoverable="true" :data="infoArray" checkable :checked-rows.sync="checkedRows" :custom-is-checked="(a, b) => a.id === b.id">
          <template slot-scope="props">
            <b-table-column field="feeType" label="Sr no" centered>
              {{ props.index + 1 }}
            </b-table-column>

            <b-table-column field="amount" label="Amount" centered> <span class="mdi mdi-currency-inr"></span>{{ props.row.amount }}</b-table-column>

            <b-table-column field="amountName " label="Fee Name" sortable centered> {{ props.row.name }}</b-table-column>
          </template>
          <template slot="footer" v-if="infoArray.length > 0">
            <th>
              <div>
                <div></div>
              </div>
            </th>
            <th>
              <div>
                <div class="has-text-centered">Total</div>
              </div>
            </th>
            <th>
              <div>
                <div class="has-text-centered"><span class="mdi mdi-currency-inr"></span> {{ totalAmount.toFixed(2) }}</div>
              </div>
            </th>
            <th>
              <div>
                <div class="has-text-centered"></div>
              </div>
            </th>
          </template>
          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                </p>
                <p>No Particulars Data.</p>
              </div>
            </section>
          </template>
        </b-table>
      </card-component>
    </section>
    <section class="section is-main-section">
      <div class="level">
        <!-- Left side -->
        <div class="level-left"></div>

        <div class="level-right">
          <div class="level-item">
            <b-button type="is-info" icon-right="arrow-right-bold" id="rzp-button1" :disabled="payTotal > 0 ? false : true" @click="captureResponse">
              Pay (<span class="mdi mdi-currency-inr"></span>{{ payTotal.toFixed(2) }})
            </b-button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import _ from 'lodash'
import ThankYou from './thankYou'
import ErrorPage from './error'

export default {
  name: 'RazorPay',
  components: {
    CardComponent,
    ThankYou,
    ErrorPage
  },
  props: ['enquiryid'],
  data () {
    return {
      isPrint: true,
      tots_image: `${constants.RAZORPAY.TOTS_IMAGE}`,
      totalAmount: 0,
      total: 0,
      paginated: false,
      perPage: 10,
      loadingComponent: null,
      isCustom: false,
      infoArray: [],
      checkedRows: [],
      concessionTotal: 0,
      info: {},
      response: [],
      orderID: '',
      isSuccess: false,
      isError: false,
      sendCaptureRespos: []
    }
  },

  beforeCreate () {
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', `${constants.RAZORPAY.JS}`)
    document.head.appendChild(recaptchaScript)
  },

  async created () {
    await this.getAllInfo()
  },
  computed: {
    payTotal: function () {
      return this.totalAmount
    }
  },
  methods: {
    closePopUp () {
      this.isSuccess = false
      window.location.href = constants.FRONTEND
    },
    captureResponse: async function (event) {
      try {
        this.loadingComponent = this.$buefy.loading.open()

        const { data } = await http.post(`${constants.API_URL}/api/payments/order`, { referenceID: this.enquiryid, assignFeeInstallmentID: _.map(this.checkedRows, 'id'), amount: this.payTotal })
        this.Pay(event, data)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        this.isError = true
      } finally {
        this.loadingComponent.close()
      }
    },
    getActiveAmount: function (values, old) {
      this.calculateTotalOnEvent(values)
    },
    Pay: async function (event, resultantObj) {
      try {
        let self = this
        this.orderID = resultantObj.orderID
        var options = {
          key: `${constants.RAZORPAY.RAZOR_KEY}`, // Enter the Key ID generated from the Dashboard
          amount: this.payTotal, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
          currency: 'INR',
          name: 'Firstcry Intellitots',
          description: `${constants.RAZORPAY.FEE_TYPE.APPLICATION_FEE}`,
          image: `${constants.RAZORPAY.TOTS_IMAGE}`,
          order_id: this.orderID, // This is a sample Order   ID. Pass the `id` obtained in the response of Step 1
          handler: async function (response) {
            await self.postCapture(response.razorpay_payment_id)
            self.isSuccess = true
          },
          prefill: {
            name: this.info.enquiry.fatherName,
            email: 'SXXXXXXXX@gmail.com',
            contact: '9999999999'
            // email: this.info.enquiry.fatherEmailID,
            // contact: this.info.enquiry.fatherMobile
          },
          notes: {
            address: 'Razorpay Corporate Office'
          },
          theme: {
            color: `${constants.RAZORPAY.COLOR}`
          }
        }

        let rzp = new window.Razorpay(options)

        rzp.on('payment.failed', function (response) {
          if (response && response.error.code && response.error.description) {
            alert(`${response.error.code} ${response.error.description}`)
          } else {
            alert('Something Went Wrong ! Please try again')
          }
        })

        rzp.open()

        event.preventDefault()
      } catch (err) {
        self.isError = true
      }
    },
    postCapture: async function (key) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        this.sendCaptureRespos = await http.post(`${constants.API_URL}/api/payments/capture`, { paymentID: key })

        this.sendCaptureRespos = await http.get(`${constants.API_URL}/api/invoice/${this.sendCaptureRespos.data.paymentOrderData.id}`)

        this.isSuccess = true
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        this.isError = true
      } finally {
        this.loadingComponent.close()
      }
    },
    getAllInfo: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let { data } = await http.get(`${constants.API_URL}/api/assign-application-fee/${this.enquiryid}`)
        this.infoArray = data
        this.info = data[0] || {}

        this.loadingComponent.close()
        if (!this.info) {
          this.total = 0
        } else {
          this.total = this.info.length
        }
      } catch (e) {
        this.loadingComponent.close()

        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    calculateTotalOnEvent: function (values) {
      // this.concessionTotal = _.sumBy(values, item => {
      //   return item && item.amountConcession ? Number(item.amountConcession) : 0
      // })

      this.totalAmount = _.sumBy(values, item => {
        return item && item.amount ? Number(item.amount) : 0
      })
    }
  }
}
</script>
